import { useMemo, useState } from "react";
import CloseIcon from "../../assets/icons/CloseIcon";
import MinusIcon from "../../assets/icons/MinusIcon";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { addProductToCart, addProductToCartWithQuantity, clearProductInCart, removeProductInCart, updateQuantityProductInCart } from "../../store/slices/cartSlice";
import { setProductDetail } from "../../store/slices/productSlice";
import { disableScrollScreen, enableScrollScreen, showComboDetailModal, showProductDetailModal } from "../../store/slices/uiSlice";
import { ICombo } from "../../types/combo";
import { getCartState } from "../../store";
import PlusIcon from "../../assets/icons/PlusIcon";
import CheckIcon from "../../assets/icons/CheckIcon";
import { formatProductInCart } from "../../helpers/handleProduct";
import { setComboSelected } from "../../store/slices/comboSlice";
import { formatHTMLString } from "../../helpers/handleString";

interface IModalComboProps {
    combo: ICombo;
}
export default function ModalComboDetail({ combo }: IModalComboProps) {
    const dispatch = useAppDispatch();
    const { cartInfo } = useAppSelector(getCartState);
    const comboInCart = useMemo(() => {
        return cartInfo.find(item => item.id === combo.id);
    }, [cartInfo, combo])
    const [quantity, setQuantity] = useState<number>(() => comboInCart ? comboInCart.quantity : 1);
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center pt-10 pb-4 max-md:px-2">
            <div className="bg-white w-full max-w-[750px] rounded-sm shadow-xl flex flex-col justify-between max-md:w-full max-xl:w-[80%] max-md:gap-0">
                <div className="p-3 flex justify-between gap-2 items-center border-b border-gray-300 border-solid">
                    <p className="text-xl font-medium">{combo.name}</p>
                    <button
                        onClick={() => {
                            dispatch(showComboDetailModal());
                            dispatch(enableScrollScreen());
                            dispatch(setComboSelected({} as ICombo));
                        }}
                    >
                        <CloseIcon />
                    </button>
                </div>
                <div className="overflow-y-auto flex-1">
                    {combo.content
                        ? <div id="product-content" className="font-normal text-base p-3" dangerouslySetInnerHTML={{ __html: formatHTMLString(combo.content) }}></div>
                        : <div className="font-normal text-base p-3">{combo.description}</div>
                    }
                    <div className="flex flex-col gap-2 px-4 py-2">
                        {combo && combo.products && combo.products.length > 0 && combo.products.map(product => (
                            <div key={product.id} className="flex justify-center gap-4">
                                <button className="flex justify-center items-start"
                                    onClick={() => {
                                        dispatch(showProductDetailModal());
                                        dispatch(disableScrollScreen());
                                        dispatch(setProductDetail(product));
                                        dispatch(showComboDetailModal());
                                    }}
                                >
                                    <img src={product.photos && product.photos.length > 0
                                        ? product.photos[0]
                                        : "http://static.salekit.com/public/images/no-image.png"
                                    }
                                        alt="Ảnh"
                                        className="w-20 h-auto"
                                    />
                                </button>
                                <div className="w-full">
                                    <h1 className="text-[#182537] text-base font-medium break-words cursor-pointer w-full"
                                        onClick={() => {
                                            dispatch(showProductDetailModal());
                                            dispatch(disableScrollScreen());
                                            dispatch(setProductDetail(product));
                                            dispatch(showComboDetailModal());
                                        }}
                                    >
                                        {product.name}
                                    </h1>
                                    <div className="flex items-end justify-between mt-2">
                                        <div
                                            className="flex items-center gap-2"
                                            onClick={() => {
                                                dispatch(showProductDetailModal());
                                                dispatch(disableScrollScreen());
                                                dispatch(setProductDetail(product));
                                                dispatch(showComboDetailModal());
                                            }}
                                        >
                                            <p className="text-[#46515F] text-base font-normal cursor-pointer ">
                                                {product.quantity} x {Number(product.unit_price).toLocaleString("vi-VN")}
                                            </p>
                                            {/* {+product.unit_price > 0
                                            && +product.unit_price !== +product.price_sale
                                            && <p className="line-through text-sm font-normal cursor-pointer"
                                                style={{ color: "rgba(70, 81, 95, 0.5)" }}
                                            >
                                                {Number(product.unit_price).toLocaleString("vi-VN")}
                                            </p>} */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="p-4 flex flex-col gap-4 border-t border-gray-300 border-solid">
                    <div className="flex justify-between items-center">
                        <div className="flex w-full items-center gap-4">
                            <p className="text-base font-normal">Số lượng</p>
                            <div className="flex items-center gap-2 flex-1">
                                <button
                                    onClick={() => {
                                        if (comboInCart) {
                                            dispatch(removeProductInCart(comboInCart.id))
                                        }
                                        if (quantity < 2) return;
                                        setQuantity((prev) => (prev = prev - 1));
                                    }}
                                >
                                    <MinusIcon />
                                </button>
                                <input
                                    type="text"
                                    value={quantity}
                                    className="w-20 text-center outline-none border-b border-gray-200 border-solid"
                                    onChange={(ev) => {
                                        const value = +ev.target.value;
                                        setQuantity((prev) => prev = value);
                                    }}
                                    onBlur={() => {
                                        if (!quantity) {
                                            dispatch(clearProductInCart({ id: combo.id }));
                                            setQuantity(1);
                                        } else {
                                            dispatch(updateQuantityProductInCart({ id: combo.id, quantity: quantity }))
                                        }
                                    }}
                                />
                                <button onClick={() => {
                                    if (comboInCart) {
                                        dispatch(addProductToCart(comboInCart))
                                    }
                                    setQuantity((prev) => (prev = prev + 1));
                                }}>
                                    <PlusIcon />
                                </button>
                            </div>
                            <div className="flex items-center gap-2">
                                {+combo.combo_price > 0
                                    && +combo.combo_price !== +combo.price_sale
                                    && <p className="line-through text-sm font-normal cursor-pointer"
                                        style={{ color: "rgba(70, 81, 95, 0.5)" }}
                                    >
                                        {(+combo.combo_price).toLocaleString("vi-VN")}
                                    </p>
                                }
                                <h1 className="font-medium text-base">
                                    {Number(combo.price_sale).toLocaleString("vi-VN")}
                                </h1>
                            </div>
                        </div>
                    </div>
                    <button
                        className="w-full flex justify-center gap-2 items-center bg-[#0088FF] text-white text-xl font-medium px-3 py-2 rounded-md"
                        onClick={() => {
                            if (comboInCart) return;
                            dispatch(
                                addProductToCartWithQuantity({
                                    quantity: quantity,
                                    product: formatProductInCart(combo, "combo"),
                                })
                            );
                            // dispatch(showProductDetailModal());
                            // dispatch(enableScrollScreen());
                        }}
                    >
                        {comboInCart && <CheckIcon width="28" height="28" />}
                        {comboInCart ? "Đã thêm vào giỏ hàng" : "Thêm vào giỏ hàng"}
                    </button>
                </div>
            </div>
        </div>
    )
}